import { useCallback, useEffect, useState } from "react";

import useAssistantPanelLearnStore from "../../useStore";
import useAssistantPanelLearnActiveGuide from "../../useActiveGuide";
import { CompletedGuideData } from "../../types";
import AssistantPanelLearnActiveGuideViewSkeleton from "./Skeleton";
import AssistantPanelLearnActiveGuideViewStep from "./Step";
import AssistantPanelLearnActiveGuideViewCompletionStep from "./CompletionStep";

const AssistantPanelLearnActiveGuideView = () => {
  const { setNavigationState } = useAssistantPanelLearnStore();
  const {
    activeGuide,
    currentStep,
    currentStepIndex,
    totalSteps,
    loading,
    nextGuideId,
    isNextGuideCompleted,
  } = useAssistantPanelLearnActiveGuide();

  const [justCompletedGuide, setJustCompletedGuide] = useState<CompletedGuideData | undefined>();

  useEffect(() => {
    if (!loading && !activeGuide && !justCompletedGuide) {
      setNavigationState({ level: "groups" });
    }
  }, [loading, activeGuide, justCompletedGuide, setNavigationState]);

  const handleOnGuideCompleteClick = useCallback(() => {
    if (!activeGuide) return;

    setJustCompletedGuide({
      guideTitle: activeGuide.metadata.title,
      completionMessage: activeGuide.completion.successMessage,
      nextGuideId,
      totalSteps,
      isNextGuideCompleted,
    });
  }, [activeGuide, totalSteps, nextGuideId, isNextGuideCompleted]);

  if (loading && !activeGuide) {
    return <AssistantPanelLearnActiveGuideViewSkeleton />;
  }

  if (activeGuide && currentStep) {
    return (
      <AssistantPanelLearnActiveGuideViewStep
        guideTitle={activeGuide.metadata.title}
        currentStep={currentStep}
        currentStepIndex={currentStepIndex}
        totalSteps={totalSteps}
        onCompleteClick={handleOnGuideCompleteClick}
      />
    );
  }

  if (justCompletedGuide) {
    return <AssistantPanelLearnActiveGuideViewCompletionStep data={justCompletedGuide} />;
  }

  return null;
};

export default AssistantPanelLearnActiveGuideView;
